import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  shebei:""
  },
  getters: {
  },
  mutations: {
	  // 获取设备
	  setShebei(state,item){
		  // console.log('vue-设备',item)
		  state.shebei = item
	  }
  },
  actions: {
  },
  modules: {
  }
})
